module.exports = __webpack_public_path__ + "static/media/art5.2aa02825.png";